import { useSelector } from 'react-redux';
import { authSelector } from '../../../store';
import { hasTenantScopedPermission } from '../../../hooks/usePermission/permissionChecks';
import type { PermissionCommons } from '../../../types/Permission';

interface HasPermissionProps extends Partial<PermissionCommons> {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}
export const HasPermission = (props: HasPermissionProps) => {
  const { children, of, fallback } = props;
  const {
    data: { privileges, isTenantSuperAdmin },
  } = useSelector(authSelector);

  if (hasTenantScopedPermission(isTenantSuperAdmin, privileges, of) || of === 'N/A') {
    return <>{children}</>;
  }
  return <>{fallback}</>;
};
